(function(window, mediaPlayerFactory) {
   'use strict';

   window._gaq = window._gaq || [];

   var namespace = window.TSC = window.TSC || {};
   namespace.mediaPlayer = mediaPlayerFactory(
      window,
      window.jQuery,
      namespace.localizationStrings,
      namespace.events,
      namespace.performanceWrapper,
      namespace.deviceInfo,
      namespace.queryParamsStripper,
      namespace.iFrameBridge,
      namespace.playerConfiguration,
      namespace.mediaType,
      namespace.MediaList,
      namespace.playerType,
      namespace.mediaPlayerController,
      namespace.reportType,
      namespace.Quiz,
      namespace.Xmp,
      namespace.fathomService,
      namespace.CaptionService,
      namespace.playerView,
      namespace.youTube,
      namespace.preRollController,
      namespace.imageView,
      namespace.quizController,
      namespace.questionGrader,
      namespace.log,
      namespace.themeController,
      namespace.cssClasses,
      namespace.scormController,
      namespace.messageBarType,
      namespace.MessageBarView
   );
})(window, function(window,
                    $,
                    localizationStrings,
                    events,
                    performanceWrapper,
                    deviceInfo,
                    queryParamsStripper,
                    iFrameBridge,
                    playerConfiguration,
                    mediaType,
                    MediaList,
                    playerType,
                    mediaPlayerController,
                    reportType,
                    Quiz,
                    Xmp,
                    fathomService,
                    CaptionService,
                    playerView,
                    youTube,
                    preRollController,
                    imageView,
                    quizController,
                    questionGrader,
                    log,
                    themeController,
                    cssClasses,
                    scormController,
                    messageBarType,
                    MessageBarView) {
   'use strict';

   // major, minor, build
   var PLAYER_VERSION = 'x.x.x';

   var _spElementId = null;
   var _$spElement = null;
   var _sentViewEvent = false;
   var _currentPlayerType = null;
   var _mediaList = null;
   var _xmp = null;
   var _quizModel = null;
   var _captionService = null;

   var mediaListError = function() {
      MessageBarView.create(_$spElement, messageBarType.warning, localizationStrings.strings.mediaNotFound);
   };

   var xmpErrorHandler = function() {
      if (_currentPlayerType === playerType.IMAGE) {
         MessageBarView.create(_$spElement, messageBarType.info, localizationStrings.strings.txtImageQuizNetworkErrorMessage, localizationStrings.strings.close);
      } else if (deviceInfo.isLocal()) {
         MessageBarView.create(_$spElement, messageBarType.info, localizationStrings.strings.xmpSecurity, localizationStrings.strings.close);
      } else {
         MessageBarView.create(_$spElement, messageBarType.info, localizationStrings.strings.xmpError);
      }
   };

   var imageQuizLoadErrorHandler = function() {
      log.logMessage('Media-player: setupPlayer() attempted to load an image quiz that contained multiple question sets.');
      MessageBarView.create(_$spElement, messageBarType.info, localizationStrings.strings.txtBadImageQuiz);
   };

   var initAnalytics = function() {
      window._gaq.push(['_setAccount', playerConfiguration.getGoogleAnalyticsID()]);

      if (playerConfiguration.getGAPageViewTracking()) {
         window._gaq.push(['_trackPageview', playerConfiguration.getMediaFileName()]);
      }

      (function() {
         var ga = document.createElement('script');
         ga.setAttribute('data-tsc-app-name', 'tsc-smart-player');
         ga.type = 'text/javascript';
         ga.async = true;
         ga.src = 'https://ssl.google-analytics.com/ga.js';
         var s = document.getElementsByTagName('script')[0];
         s.parentNode.insertBefore(ga, s);
      })();
   };

   var onPreRollStart = function() {
      continueInit();
   };

   var initPlayer = function() {
      setupServices();
      playerView.setupServices(_captionService);

      deviceInfo.lookAtDevice();

      queryParamsStripper.strip();

      themeController.setSmartPlayerContainerElement(_$spElement);

      if (playerConfiguration.getPreRollSrc()) {
         preRollController.createView(playerConfiguration.getPreRollSrc(), onPreRollStart);
      } else {
         continueInit();
      }
   };

   var continueInit = function() {
      var mediaSources = playerConfiguration.getMediaSources();
      _mediaList = MediaList.create(mediaSources);
      _mediaList.ready.then(mediaListReady, mediaListError);
   };

   var playbackInitiatedHandler = function() {
      playerView.removeEventListener(events.External.VideoStartInitiated, playbackInitiatedHandler);
      if (preRollController && preRollController.viewExists()) {
         preRollController.destroyView();
      }
   };

   var playerStartedHandler = function() {
      if (!_sentViewEvent) {
         if (_currentPlayerType !== playerType.IMAGE) {
            playerView.removeEventListener(events.External.VideoStart, playerStartedHandler);
         }
         $(document).trigger('techsmith.cloud.viewedMedia');
         _sentViewEvent = true;
      }
   };

   var mediaListReady = function() {
      _currentPlayerType = mediaPlayerController.getPlayerType(_mediaList);

      switch (_currentPlayerType) {
         case playerType.YOUTUBE: {
            youTube.addApi();
            processMediaAssets();
            break;
         }
         case playerType.HTML5_VIDEO: {
            processMediaAssets();
            break;
         }
         case playerType.TSCPROJ: {
            processMediaAssets();
            break;
         }
         case playerType.IMAGE: {
            processMediaAssets();
            break;
         }
         case playerType.NOT_SUPPORTED: {
            if (_mediaList.currentMediaType === mediaType.WEBM) {
               MessageBarView.create(_$spElement, messageBarType.warning, localizationStrings.strings.noWebMSupport);
            } else {
               MessageBarView.create(_$spElement, messageBarType.warning, localizationStrings.strings.videoNotSupported);
            }
            break;
         }
      }
   };

   var initQuiz = function(container) {
      if (quizController.hasQuiz && quizController.quizEnabled) {
         quizController.setViewContainer(container);
         var grader;
         if (playerConfiguration.getFathomId()) {
            grader = questionGrader.FATHOM;
         } else {
            grader = questionGrader.XMP;
         }
         quizController.setQuestionGrader(grader);
      }
   };

   var processMediaAssets = function() {
      if (playerConfiguration.getGoogleAnalyticsID()) {
         initAnalytics();
      }
      processXMP();
   };

   var setQuizModel = function(xmpModel) {
      if (xmpModel && xmpModel.hasQuiz) {
         _quizModel = Quiz.create(xmpModel);
         quizController.quizModel = _quizModel;
      }
   };

   var processQuizzing = function(successCallback) {
      if (playerConfiguration.getFathomId()) {
         fathomService.addEventListener('GET_COMPLETE', function(xmpModel) {
            setQuizModel(xmpModel);
            setupPlayer();
            if (typeof successCallback === 'function') {
               successCallback();
            }
         });
         fathomService.addEventListener('ERROR', function() {
            setupPlayer();
            xmpErrorHandler();
         });
         fathomService.getFathom(playerConfiguration.getFathomId());
      } else {
         setQuizModel(_xmp);
         setupPlayer();
      }
   };

   var processXMP = function() {
      if (playerConfiguration.getXMPSrc()) {
         _xmp = Xmp.create();

         if (typeof window.TSC.embedded_config_xml === 'string') {
            _xmp.parse(window.TSC.embedded_config_xml);
         } else {
            _xmp.load(playerConfiguration.getXMPSrc(), false);
         }

         _xmp.ready.then(function() {
            playerConfiguration.configureFromXmp(_xmp);
            localizationStrings.configureFromXmp(_xmp);
            processQuizzing();
         }).catch(function() {
            processQuizzing();
            xmpErrorHandler();
         });
      } else {
         processQuizzing();
      }
   };

   var captionChangeHandler = function(text) {
      if (iFrameBridge.isInIframe()) {
         iFrameBridge.postMessage('CAPTION-CHANGED', '*', text);
      }
   };

   var setupServices = function() {
      _captionService = CaptionService.create();
   };

   var setupBasicCss = function() {
      _$spElement.addClass(cssClasses.smartPlayerNamespace);

      if (playerConfiguration.getUseLargerProgressBar()) {
         _$spElement.addClass(cssClasses.largerProgressBar);
      }

      // mainly for backwards compat for pre-version 3.38.0 traverse parent-chain and set height/pad/etc if default
      if (playerConfiguration.getFullViewPort()) {
         _$spElement.parents().each(function(index, parentNode) {
            var $parentNode = $(parentNode);
            $parentNode.height('100%');
            if ($parentNode.prop('tagName').toLowerCase() === 'body') {
               $parentNode.css({
                  margin: 0,
                  padding: 0,
                  border: 0,
                  overflow: 'hidden'
               });
            }
         });
      }
   };

   var initPlayerView = function(displaySidebar, displayLocalWarning) {
      playerView.addEventListener(events.External.VideoStartInitiated, playbackInitiatedHandler);
      playerView.addEventListener(events.External.VideoStart, playerStartedHandler);
      playerView.addEventListener(events.External.CaptionChange, captionChangeHandler);

      if (mediaPlayerController.getPlayerType(_mediaList) === window.TSC.playerType.YOUTUBE) {
         playerView.initYouTubeView(_spElementId, displaySidebar, _mediaList, _xmp);
      } else if (mediaPlayerController.getPlayerType(_mediaList) === window.TSC.playerType.TSCPROJ) {
         playerView.initTscProjView(_spElementId, displaySidebar, _mediaList, _xmp);
      } else {
         playerView.initHtml5View(_spElementId, displaySidebar, _mediaList, _xmp);
      }

      if (displayLocalWarning) {
         MessageBarView.create(_$spElement, messageBarType.info, localizationStrings.strings.xmpSecurity, localizationStrings.strings.close);
      }
   };

   var setupPlayer = function() {
      var displaySidebar = false;
      var displayLocalWarning = false;

      if (_currentPlayerType === playerType.IMAGE) {
         _$spElement.addClass('image-view');
      } else {
         _$spElement.addClass('video-view');
      }

      // General image path
      if (_currentPlayerType === playerType.IMAGE) {
         imageView.initView(_$spElement, _mediaList.currentMedia.media, playerStartedHandler);

         initQuiz(_$spElement);
         quizController.setSmartplayerElement(_$spElement);
         quizController.gatherSetupIfNeeded();

         if (quizController.hasQuiz && _quizModel.numberQuestionSets > 0) {
            if (quizController.hasMultipleQuestionSets()) {
               imageQuizLoadErrorHandler();
            } else {
               imageView.initEvents();
            }
         }

         //Record the view in quizzing analytics
         quizController.simpleInit();
         quizController.forceProgressUpdate(100, [0]);
      // advanced HTML5_VIDEO path
      } else {
         initQuiz(_$spElement);
         if (_xmp) {
            if (_xmp.hasTocItems || _xmp.hasSearchableItems && playerConfiguration.getIsSearchable()) {
               displaySidebar = true;
            }

            if (_xmp.hasCaptionItems) {
               if (iFrameBridge.isInIframe()) {
                  iFrameBridge.postMessage('HAS-CAPTIONS', '*');
               }
            }
         }

         if (quizController.hasQuiz) {
            if (deviceInfo.isLocal() && _quizModel.reportMethod !== reportType.NONE) {
               displayLocalWarning = true;
               _quizModel.reportMethod = reportType.NONE;
            } else if (_quizModel.useScorm && _quizModel.totalNumberOfGradedQuestionSets === 0) {
               // legacy scorm support
               if (typeof window.onVideoWatchedPercentage === 'function') {
                  playerConfiguration.setReportScormComplete(true);
                  // Built in Scorm support
               } else {
                  playerConfiguration.isScormLesson = true;
               }
            }
         }

         if (playerConfiguration.isScormLesson) {
            scormController.init().then(function() {
               initPlayerView(displaySidebar, displayLocalWarning);
            });
         } else {
            initPlayerView(displaySidebar, displayLocalWarning);
         }
      }
   };

   var triggerEvent = function(eventName, data) {
      if (_$spElement) {
         _$spElement.trigger(eventName, data);
      }
   };

   var init = function(spElementId) {
      performanceWrapper.createMarker(events.Timing.PlayerInitialized);
      _spElementId = spElementId;
      _$spElement = $(_spElementId);
      setupBasicCss();
      initPlayer();
   };

   var getSmartPlayerRootElement = function() {
      return _$spElement;
   };

   var destroy = function() {
      if (!_$spElement) {
         return;
      }
      playerView.removeEventListener(events.External.VideoStartInitiated, playbackInitiatedHandler);
      playerView.removeEventListener(events.External.VideoStart, playerStartedHandler);
      playerView.removeEventListener(events.External.CaptionChange, captionChangeHandler);
      playerView.destroy();

      _$spElement.removeClass(cssClasses.smartPlayerNamespace + ' ' + cssClasses.largerProgressBar + ' video-view image-view');

      _spElementId = null;
      _$spElement = null;
      _sentViewEvent = false;
      _currentPlayerType = null;
      _mediaList = null;
      _xmp = null;
      _quizModel = null;
      _captionService = null;
   };

   var getVersion = function() {
      return PLAYER_VERSION;
   };

   var jsSeekTime = function(time) {
      playerView.jsSeekTime(time);
   };

   var jsPlay = function() {
      playerView.jsPlay();
   };

   var jsDebugUI = function() {
      return 'HTML5_VIDEO player does not support this method.';
   };

   return Object.defineProperties({
      init: init,
      getSmartPlayerRootElement: getSmartPlayerRootElement,
      destroy: destroy,
      getVersion: getVersion,
      jsSeekTime: jsSeekTime,
      jsPlay: jsPlay,
      jsDebugUI: jsDebugUI,
      addEventListener: playerView.addEventListener,
      removeEventListener: playerView.removeEventListener,
      triggerEvent: triggerEvent
   }, {});
});
